export default __webpack_public_path__ + "static/media/applicant_content.b998dab6.svg";